import React from 'react';
import { Alert } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { isNoQuantityAllowed } from './CrewTimesheet';

export default class ContractPhaseQuantityDisplay extends React.Component {
    render() {
        const { timesheetContractPhase, contractPhase, unitOfMeasure } =
            this.props;

        if (
            !timesheetContractPhase ||
            !contractPhase ||
            isNoQuantityAllowed(timesheetContractPhase)
        ) {
            return null;
        }

        const showTargetQuantity = Boolean(
            timesheetContractPhase &&
            timesheetContractPhase.targetQuantity &&
            timesheetContractPhase.targetQuantity > 0
        );

        return (
            <div>
                {showTargetQuantity && (
                    <div>
                        As a reminder, the target quantity was{' '}
                        {timesheetContractPhase.targetQuantity} {unitOfMeasure}.
                    </div>
                )}

                {Boolean(
                    !showTargetQuantity &&
                    contractPhase.quantity &&
                    timesheetContractPhase.quantity <= contractPhase.quantity
                ) && (
                    <div>
                        As a guideline, the total estimated quantity was{' '}
                        {contractPhase.quantity} {unitOfMeasure}.
                    </div>
                )}

                {Boolean(
                    contractPhase.quantity &&
                    timesheetContractPhase.quantity > contractPhase.quantity
                ) && (
                    <Alert color="danger" fade={false} className="mt-2">
                        <FontAwesomeIcon
                            icon={faExclamationCircle}
                            className="mr-2"
                        />
                        Warning: the contract estimated a total of{' '}
                        {contractPhase.quantity} {unitOfMeasure}.
                    </Alert>
                )}
            </div>
        );
    }
}
